import React, { useState } from "react";
import SubmitButton from "../buttons/SubmitButton";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import { DatePicker, Input } from "antd";
const { RangePicker } = DatePicker;

const SilverTableFilter = ({
  type,
  setApiTab,
  selectedCategory,
  setSelectedCategory,
  setDateRange,
  category,
  setCurrentPage,
  userType,
  setUserType,
  setPairs,
  pairs
}) => {
  const categoryList = [];
  const listOptions = [];
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = useState(selectedCategory);
  const [dateKey, setDateKey] = useState(Date.now());
  const [date, setDate] = useState({ startDate: "", endDate: "" });
  const [pairValue, setPairValue] = useState('');
  const transferCategory = [
    { label: t("credit"), value: "credit" },
    { label: t("debit"), value: "debit" },
  ];
  // Adding lang to the category
  category?.map((item) => {
    const data = {
      label: t(`${item.label}`),
      value: item.value,
    };
    listOptions.push(data);
  });

  const handleTabChange = (e) => {
    Object.entries(selectedValue).map(([key, value]) => {
      categoryList.push(value.value);
    });
    setSelectedCategory(categoryList);
    setDateRange({
      startDate: date.startDate,
      endDate: date.endDate
    });
    if (e.target.id === "searchButton") {
      setCurrentPage(1);
      setPairs(pairValue)
      if (type === "transfer_history") {
        setApiTab(type);
      } else if (type === "my_earnings") {
        setApiTab(type);
      }
    } else if (e.target.id === "resetButton") {
      setCurrentPage(1);
        setDateRange({ startDate: "", endDate: "" });
        setDate({ startDate: "", endDate: "" });
        setSelectedCategory([]);
        setSelectedValue([])
        setApiTab(type);
        setDateKey(Date.now());
    }
  };

  const handleSelectChange = (values) => {
    setSelectedValue(values);
  };

  const handleDateRange = (dates) => {
    if (Array.isArray(dates) && dates.length === 2) {
      const [toDate, fromDate] = dates;
      setDate({
        startDate: toDate.format("YYYY-MM-DD"),
        endDate: fromDate ? fromDate.format("YYYY-MM-DD") : null
      });
    }
  };

  const handlePairsChange = (e) => {
    const { value } = e.target;
    // setPairs(value)
    setPairValue(value)
  }
  
  return (
    <div className="filter_Section">
      <div className="row">
        <div key={"1"} className="col-xl-2 col-md-3">
          <div className="right_search_div">
            <label className="la-control">{t("date")}</label>
            <RangePicker key={dateKey} onChange={(dates) => handleDateRange(dates)} />
          </div>
        </div>       
         <div className="col-xl-2 col-md-3">
          <label className="la-control">Type</label>
          <Select
            defaultValue="individual"
            value={{value: userType, label: userType.charAt(0).toUpperCase() + userType.slice(1)}}
            style={{ width: 120 }}
            onChange={(e) => {
              setUserType(e.value);
            }}
            options={[
              { value: "individual", label: "Individual" },
              { value: "downlines", label: "Downlines" },
            ]}
          />
        </div>
        {userType === "downlines" &&
        <div className="col-xl-2 col-md-3">
          <label className="la-control">Pairs</label>
          <Input type="number" placeholder="0" value={pairValue} onChange={handlePairsChange} style={{ padding: "7px 10px" }} />
        </div>}
        {!!(type === "transfer_history") && (
          <div key={"2"} className="col-xl-2 col-md-3">
            <div className="right_search_div">
              <label className="la-control">{t("category")}</label>
              <Select
                options={transferCategory}
                value={selectedValue}
                onChange={handleSelectChange}
                isMulti
              />
            </div>
          </div>
        )}
        {!!(type === "my_earnings") && (
          <div key={"2"} className="col-xl-3 col-md-3">
            <div className="right_search_div">
              <label className="la-control">{t("category")}</label>
              <Select
                options={listOptions}
                value={selectedValue}
                onChange={handleSelectChange}
                isMulti
              />
            </div>
          </div>
        )}
        <div className="col-xl-2 col-md-3 mt-4">
          <div className="right_search_div d-flex gap-1">
            <SubmitButton
              isSubmitting=""
              text="search"
              className="btn btn-primary"
              click={handleTabChange}
              id="searchButton"
            />
            <SubmitButton
              isSubmitting=""
              text="reset"
              className="btn btn-secondary"
              click={handleTabChange}
              id="resetButton"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SilverTableFilter;